import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunOpeningFailedAction = {
	type: 'WORKFLOW_RUN_OPENING_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunOpeningFailedAction => ({
	type: 'WORKFLOW_RUN_OPENING_FAILED',
	payload,
});
